


































import Vue from 'vue';
import pxModal from '@/dex-shared/components/px-modal.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import { CourseBoardsModel } from '@descomplica/dex-models';
import CourseBoardCard from '@/components/cards/CourseBoardCard.vue';

const DEFAULT_CLASSROOM = {
  id: null,
  name: '',
  description: '',
};

export default Vue.extend({
  components: {
    CourseBoardCard,
    pxButton,
    pxModal,
  },

  props: {
    course: {
      type: Object,
      required: true,
    },
  },

  data: function() {
    return {
      addBoard: false,
      description: null,
      boardId: null,
      suggestedPeriod: null,
    };
  },

  methods: {
    toggleAddBoardModal() {
      this.addBoard = !this.addBoard;
      this.description = null;
      this.boardId = null;
      this.suggestedPeriod = null;
    },

    async addCourseBoard() {
      const duplicateBoard = this.course.courseBoardsByCourseId.nodes.find(
        courseBoard => {
          return courseBoard.boardByBoardId.id === parseInt(this.boardId);
        },
      );
      if (duplicateBoard) {
        alert('Esse mural já está associado a esse curso.');
        return;
      }
      try {
        await this.$store.dispatch('CREATE_COURSE_BOARD', {
          description: this.description,
          courseId: this.course.id,
          boardId: parseInt(this.boardId),
          suggestedPeriod: parseInt(this.suggestedPeriod),
        });
      } catch (e) {
        alert(
          `Algo deu errado. Envie essas informações para os desenvolvedores: ${e}`,
        );
      }
      this.toggleAddBoardModal();
      await this.$store.dispatch('PULL_COURSE', this.course.id);
    },
  },
});
